export default {
  name: 'Support Helpdesk',
  firstName: 'Support',
  lastName: 'Helpdesk',
  region: 'support',
  role: 'Help & Information',
  tel: '+44 330 828 5766',
  email: 'support@sellmylivestock.co.uk',
  avatarUrl: require('@/assets/images/account-managers/support.jpg'),
  userRef: process.env.VUE_APP_GENERIC_SUPPORT_USER_REF
}
